/*$('body').on('click', '.selected-coutry', function() {
    $(this).parent().find('.shipping-to-select').toggleClass('hidden');
});
$('body').on('click', '.shipping-popup-to-country-name', function() {
    $(this).parent().find('.shipping-to-select').toggleClass('hidden');
});*/
function calBusinessDay(days){
	let d = Date.today(), index = 0;
	while (index < days){
		if(d.is().saturday() || d.is().sunday()){
			d = d.next().monday();
			continue;
		}
		d = d.addDays(1);
		index++;
	}
	if(d.is().saturday() || d.is().sunday()){
		d = d.next().monday();
	}
   console.log(d);
	return d;
} 
function calShippingProcessDays(countryCode) {
	if (!countryCode) {
		return;
	}
	let from = 21, to = 29, processed = 1, produced = 8, orderShip = 9;
	if(countryCode === 'US') {
		from = 15;
		to = 21;
	}
  
	let fromDate = calBusinessDay(from);
	let toDate = calBusinessDay(to);
	let orderPlaceDate = Date.today();
	let processedDate = calBusinessDay(processed);
	let producedDate = calBusinessDay(produced);
	let orderShipDate = calBusinessDay(orderShip);
	$('.shipping-form-date').text(fromDate.toString("MMM dd"));
	$('.shipping-to-date, .shipping-delivered-date').text(toDate.toString("MMM dd"));
	$('.shipping-orderplace-date').text(orderPlaceDate.toString("MMM dd"));
	$('.shipping-processed-date').text(processedDate.toString("MMM dd"));
	$('.shipping-produced-date').text(producedDate.toString("MMM dd"));
	$('.shipping-ordership-date').text(orderShipDate.toString("MMM dd"));
}
function calShippingProcessDaysDS(countryCode) {
	if (!countryCode) {
		return;
	}

	let from = 15, to = 20, processed = 1, produced = 4, orderShip = 6;
	if(countryCode === 'US') {
      if($('body.product-ds').length){
        from = 7;
		to = 12;
     //   $('.shipping-express').append('Or faster delivery with <strong>Express Shipping </strong>');
      //  $('.notify-cut-off').append('<div class="notify-text"><span> 📦 Ornament Orders placed after <b class="text--red"> <span class="date-after-us">Dec 12</span> may not</b> be delivered by Christmas day </span></div>');
      } else{
      if($('div.acrylic-ornament').length){
          from = 7;
    	  to = 12;
         // $('.shipping-express-2').append('Or faster delivery with <strong>Express Shipping (5 -8 Business Days)</strong>');
      }
      else{
        from = 12;
		to = 15;
      }
    }
    }
	let fromDate = calBusinessDay(from);
	let toDate = calBusinessDay(to);
	let orderPlaceDate = Date.today();
	let processedDate = calBusinessDay(processed);
	let producedDate = calBusinessDay(produced);
	let orderShipDate = calBusinessDay(orderShip);
	$('.shipping-form-date').text(fromDate.toString("MMM dd"));
	$('.shipping-to-date, .shipping-delivered-date').text(toDate.toString("MMM dd"));
	$('.shipping-orderplace-date').text(orderPlaceDate.toString("MMM dd"));
	$('.shipping-processed-date').text(processedDate.toString("MMM dd"));
	$('.shipping-produced-date').text(producedDate.toString("MMM dd"));
	$('.shipping-ordership-date').text(orderShipDate.toString("MMM dd"));   
}

/* $.getJSON('https://restcountries.com/v2/all', function(data) {
	let countries = [];
	let countryOptionsHtml = '';
	for (let country of data) {
		countries[country.alpha2Code] = country.name;
		countryOptionsHtml += `<option value="${country.alpha2Code}">${country.name}</option>`;
	}
	$('.shipping-to-select').html(countryOptionsHtml);
	$('body').on('change', '.shipping-to-select', function() {
		let val = $(this).val();
        if($('body.product-aopshipping').length || $('body.product-personalize').length || $('body.product').length) {
    		if (countries[val]) {
    			$('.shipping-popup-to-country-name').text(countries[val]);
    			calShippingProcessDays(val);
    		}
        }
        if($('body.product-ds').length || $('body.product-ornament').length) {
    		if (countries[val]) {
    			$('.shipping-popup-to-country-name').text(countries[val]);
    			calShippingProcessDaysDS(val);
    		}
        }
	});

}); */
// Handle by ip address
$.getJSON('https://api.ipify.org?format=jsonp&callback=?', function(data) {
    $.getJSON(`https://api.geoapify.com/v1/ipinfo?ip=${data.ip}&apiKey=1b48259b810e48ddb151889f9ea58db0`, function(data) {
        console.log(data);
        let countryCode = data?.country?.iso_code;
        $('body').attr('country_code', countryCode);
        /*if($('body.product-aopshipping').length || $('body.product-personalize').length || $('body.product').length) {
            $('.shipping-to-country-name, .shipping-popup-to-country-name').text(data.country.name);
            $('.shipping-to-select').val(countryCode);
            calShippingProcessDays(countryCode);
        }
        if($('body.product-ds').length || $('body.product-ornament').length || $('div.acrylic-ornament').length ||$('div.t-shirts').length) {
            $('.shipping-to-country-name, .shipping-popup-to-country-name').text(data.country.name);
            $('.shipping-to-select').val(countryCode);
            calShippingProcessDaysDS(countryCode);
        }*/
        calShippingProcessDays(countryCode);
    });
 });

$(document).ready(function () {
    const cutoffDates = {
        'div.short-sleeve-women-polo-shirt, div.short-sleeve-men-polo-shirt, div.hawaiian-shirt, div.3d-baseball-jersey, div.t-shirts-aop': 'Dec 5',
        'div.tshirt, div.mugs, div.t-shirts': 'Dec 11',
        'div.crafting-canvas, div.throw-pillows': 'Dec 7',
        'div.throw-blanket': 'Dec 10',
        'div.acrylic-ornament': 'Dec 7',
        'div.shaped-acrylic-plaque': 'Dec 7'
    };

    let matched = false;

    // Kiểm tra từng selector và xử lý
    $.each(cutoffDates, function (selector, date) {
        if ($(selector).length) {
            let message = '';
            
            // Trường hợp đặc biệt với "div.acrylic-ornament"
            if (selector === 'div.acrylic-ornament') {
                message = `
                    <p style="color:black;">🔔 Within the US: Only <strong>3.5" (or 3")</strong> size ornaments are eligible for delivery before Christmas with <strong>Express Shipping</strong>. All other sizes will not arrive in time for Christmas.</p>
                    <p style="color:black;">Outside the US: Orders placed <strong>now</strong> may not be delivered by Christmas.</p>
                `;
            } else {
                message = `
                    <p style="color:black;">🔔 Within the US: Orders placed after <strong>${date} (GMT-8)</strong> may not be delivered in time for Christmas.</p>
                    <p style="color:black;">Outside the US: Orders placed <strong>now</strong> may not be delivered by Christmas.</p>
                `;
            }

            // Thêm nội dung vào container
            $('.cut_off--wrapp').append(`
                <div class="cut_off--contain">
                    ${message}
                    <span class="font-semibold">
                        (Check <a href="https://amzanimalsgift.com/pages/2024-christmas-day-shipping-cut-off-dates" 
                        title="CHRISTMAS 2024 CUTOFF DATE" target="_blank">CHRISTMAS 2024 CUTOFF DATE</a>)
                    </span>
                </div>
            `);

            matched = true;
            return false; // Dừng kiểm tra khi tìm thấy trường hợp khớp
        }
    });

    // Nếu không có trường hợp nào khớp
    if (!matched) {
        $('.cut_off--wrapp').append(`
            <div class="cut_off--contain">
                <p style="color:black;">🔔 Orders placed <strong>now</strong> may not be delivered by Christmas.</p>
                <span class="font-semibold">
                    (Check <a href="https://amzanimalsgift.com/pages/2024-christmas-day-shipping-cut-off-dates" 
                    title="CHRISTMAS 2024 CUTOFF DATE" target="_blank">CHRISTMAS 2024 CUTOFF DATE</a>)
                </span>
            </div>
        `);
    }
});
$(document).ready(function(){
  //tab homepage
  $('div.jsTabsContainer > div.hntablinks').click(function(){
      var tab_id = $(this).attr('data-tab');

      $(this).parent().find('div.hntablinks').removeClass('current');
      $('.hntab-content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
    });
  $('div.jsTabsContainer').find('div.hntablinks').first().addClass('current');
  $('.hntab-content').first().addClass('current');
  
});

$('#hnselect_box').change(function () {
  var select=$(this).find(':selected').val();        
   $(".hnsz-content").hide();
   $('#' + select).show();

}).change();

function openTab(evt, cityName) {
  var i, tabcontent, tablinks, tabsizechart, tabproduct;
  tabcontent = document.getElementsByClassName("tabcontent-cus");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks-cus");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}
document.getElementById("tab-cus-active").click();
$(document).ready(function () {
    $(".ticksell-price").each(function () {
        let text = $(this).text();
        $(this).text("(+" + text + ")");
    });
});